import { render, staticRenderFns } from "./PinReminderComponent.vue?vue&type=template&id=c2227378&scoped=true"
import script from "./PinReminderComponent.vue?vue&type=script&lang=js"
export * from "./PinReminderComponent.vue?vue&type=script&lang=js"
import style0 from "./PinReminderComponent.vue?vue&type=style&index=0&id=c2227378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2227378",
  null
  
)

export default component.exports